import {
  TIMELINE_LEGEND_NOUN,
  type TimelineLegendFilter,
} from "constants/filingsTimeline";
import { pluralize } from "utils/pluralize";

export const getLegendFilterHint = (
  filter: TimelineLegendFilter,
  count: number,
  year: number
): string => {
  const { singular, plural } = TIMELINE_LEGEND_NOUN[filter];

  return `You have ${pluralize(
    count,
    singular,
    plural
  )} for ${year}. Select a filing to view its details.`;
};
